import { motion } from "framer-motion";
import { B } from "../data/pillars";
import { getUrgency } from "../data/recommendations";

export default function RecCard({ num, rec, pillarScore }) {
  const colors   = [B.red, B.orange, B.yellow, "#3498DB", "#9B59B6", B.teal];
  const c        = colors[num - 1] || B.blue;
  const urgency  = getUrgency(pillarScore || 1);

  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: num * 0.07 }}
      style={{ background: "#122240", borderRadius: 12, padding: 22, border: `1px solid ${c}30`, marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: c, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 800, color: B.white, flexShrink: 0 }}>{num}</div>
        <div style={{ flex: 1, fontSize: 16, fontWeight: 700, color: B.white }}>{rec.title}</div>
        <span style={{ background: urgency.color + "20", color: urgency.color, fontSize: 11, fontWeight: 800, padding: "3px 10px", borderRadius: 6, border: `1px solid ${urgency.color}40`, flexShrink: 0 }}>
          {urgency.icon} {urgency.label}
        </span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 14, marginBottom: 14 }}>
        <div style={{ flex: "1 1 200px" }}>
          <div style={{ fontSize: 10, color: B.subText, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 6 }}>Business Risk</div>
          <p style={{ color: B.lightGray, fontSize: 13, lineHeight: 1.6, margin: 0 }}>{rec.risk}</p>
        </div>
        <div style={{ flex: "1 1 200px" }}>
          <div style={{ fontSize: 10, color: B.subText, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 6 }}>Remediation Action</div>
          <p style={{ color: B.white, fontSize: 13, lineHeight: 1.6, margin: 0, fontWeight: 500 }}>{rec.action}</p>
        </div>
      </div>
      {rec.compliance && (
        <div style={{ background: B.blue + "15", border: `1px solid ${B.blue}40`, borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: 12, color: B.accent }}>
          ⚖️ <strong>Compliance:</strong> {rec.compliance}
        </div>
      )}
      <div style={{ background: "#0D1B2E", borderRadius: 8, padding: "10px 14px", display: "flex", gap: 10, alignItems: "flex-start" }}>
        <div style={{ width: 28, height: 28, borderRadius: 6, background: B.blue + "30", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 14 }}>⚡</div>
        <div>
          <div style={{ fontSize: 10, color: B.subText, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 3 }}>Visual Edge IT Solution</div>
          <div style={{ color: B.white, fontSize: 13, fontWeight: 600 }}>{rec.solution}</div>
        </div>
      </div>
    </motion.div>
  );
}